import React from 'react';

import { TIconType } from '../interface';

const SpeedTestIcon: TIconType = () => {
	return (
		<svg
			data-id='icon'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<path
				d='M12.5007 2.00003C9.45305 2.00777 6.53241 3.24568 4.37741 5.44306C2.2224 7.64045 1.00837 10.6185 1.00078 13.7261C0.982876 15.2678 1.27416 16.797 1.85674 18.2198C2.43932 19.6426 3.30092 20.929 4.38865 22L5.99863 20.3584C5.13951 19.4915 4.46009 18.4573 4.00078 17.3174C3.54146 16.1774 3.31161 14.9549 3.32491 13.7226C3.32124 11.2429 4.2837 8.8633 6.00058 7.10716C7.71745 5.35102 10.0481 4.36218 12.48 4.35814H12.5007C14.9325 4.35503 17.266 5.33701 18.9878 7.08809C20.7097 8.83917 21.6788 11.2159 21.6822 13.6956V13.7214C21.6521 16.1998 20.6959 18.5731 19.0085 20.3572L20.6127 21.9988C22.2264 20.3642 23.3272 18.2773 23.7752 16.0034C24.2233 13.7294 23.9983 11.371 23.1289 9.22768C22.2595 7.08438 20.785 5.25294 18.8926 3.96602C17.0002 2.67911 14.7753 1.9948 12.5007 2.00003ZM10.1823 13.9993L12.1442 16.0901L17.8504 9.45429L16.6901 8.18201L10.1823 13.9993Z'
				fill='#141526'
			/>
		</svg>

	);
};

export default SpeedTestIcon;
